import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\UpdateFreeItemStockFromSupplierOrderItemController::__invoke
* @see app/Http/Controllers/SupplierOrder/UpdateFreeItemStockFromSupplierOrderItemController.php
* @route '/api/supplier-order-item/{supplier_order_item}/item-stocks'
*/
const UpdateFreeItemStockFromSupplierOrderItemController = (args: { supplier_order_item: string | number | { id: string | number } } | [supplier_order_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFreeItemStockFromSupplierOrderItemController.url(args, options),
    method: 'put',
})

UpdateFreeItemStockFromSupplierOrderItemController.definition = {
    methods: ["put"],
    url: '/api/supplier-order-item/{supplier_order_item}/item-stocks',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\SupplierOrder\UpdateFreeItemStockFromSupplierOrderItemController::__invoke
* @see app/Http/Controllers/SupplierOrder/UpdateFreeItemStockFromSupplierOrderItemController.php
* @route '/api/supplier-order-item/{supplier_order_item}/item-stocks'
*/
UpdateFreeItemStockFromSupplierOrderItemController.url = (args: { supplier_order_item: string | number | { id: string | number } } | [supplier_order_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order_item: typeof args.supplier_order_item === 'object'
        ? args.supplier_order_item.id
        : args.supplier_order_item,
    }

    return UpdateFreeItemStockFromSupplierOrderItemController.definition.url
            .replace('{supplier_order_item}', parsedArgs.supplier_order_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\UpdateFreeItemStockFromSupplierOrderItemController::__invoke
* @see app/Http/Controllers/SupplierOrder/UpdateFreeItemStockFromSupplierOrderItemController.php
* @route '/api/supplier-order-item/{supplier_order_item}/item-stocks'
*/
UpdateFreeItemStockFromSupplierOrderItemController.put = (args: { supplier_order_item: string | number | { id: string | number } } | [supplier_order_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFreeItemStockFromSupplierOrderItemController.url(args, options),
    method: 'put',
})

export default UpdateFreeItemStockFromSupplierOrderItemController